<!--<a href="{{node.Url}}" (click)="itemClicked(node,$event)">-->
<div [className]="containsSubItemsOfGroup(node.Children,1) && opened ? 'item main-node-item first-of-type dropdown' : 'item main-node-item first-of-type'"
  (click)="itemClicked(node,$event)">
  <div [@nodeImg]="menuState" class="node-container node-img">
    <div [@Img]="menuState" class="left-menu-node-icon"
    style="background-image: url('/assets/project-custom/images/{{node.Icon}}')"></div>
  </div>
  <div class="node-container">
    @if (opened == false) {
      <span class="tooltip-text">{{node.TooltipText}}test</span>
    }
    <p [@itemTransform]="menuState">{{node.Title}}</p>
  </div>
  <!--<a *ngFor="let url of node.Urls" class="{{url.Class}}" href="{{url.Url}}"></a>-->
</div>
<!--></a>-->

@if (containsSubItemsOfGroup(node.Children,1) && opened && node.Selected) {
  <div class="submenu">
    <div class="hover-overlay"></div>
    @for (child of node.Children | menuTypePipe:1; track child) {
      <div class="sub-item">
        <a (click)="navigate(child)">
        <!--p class="node-child" (click)="itemClicked(child,$event)">{{child.Title}}</p-->
        <sem-left-menu-item [node]="child"></sem-left-menu-item>
      </a>
      <!--<a *ngFor="let url of child.Urls" class="{{url.Class}}" href="{{url.Url}}"></a>-->
    </div>
  }
</div>
}
